module.exports = __webpack_public_path__ + "img/brown-carpet-grass-08.01fa5dde.png";